import { createFileRoute, Outlet } from '@tanstack/react-router';

/** Layout-only: gives the customer page a "Customers" crumb that links back to the list. */
export const Route = createFileRoute('/_authed/_active/s/$storeId/customers')({
  staticData: { crumb: 'common:nav.customers' },
  component: Outlet,
});
